import { render, staticRenderFns } from "./FormGroupForm.vue?vue&type=template&id=847f85e0"
import script from "./FormGroupForm.vue?vue&type=script&lang=js"
export * from "./FormGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInputs: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormInputs.vue').default})
